import { Component, ElementRef } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { BARCOLOR, DiagramDatas } from '../../diagram/diagram.component';

interface Result {
  result : Array<any>
}

@Component({
  selector: 'app-em-bu',
  templateUrl: './em-bu.component.html',
  styleUrls: ['./em-bu.component.css']
})
export class EmBuComponent {
  
  max : number = 6;
  emBu;
  versorgung = false;
  styles = [];
  
  diagramDatas : DiagramDatas;

  diagramDataInits : DiagramDatas = {
      height: 400,
      diagrams: []    
  };
  
  constructor( 
    private elementRef: ElementRef, 
    private api: ApiService 
  ) { 
    api.getEmBu().then((values) => {
      this.emBu = values;
      
      this.diagramDataInits.diagrams.push({
        bars: [
          {
            value: this.emBu.versorgungszielEm,
            color: BARCOLOR.blue,
            left: "Versorgungsziel"     
          },
          {
            value: this.emBu.ergVersorgungslueckeEm.value,
            color: BARCOLOR.red,
            right: "Versorgungslücke",
          }           
        ]
      });
      
      this.diagramDatas = Object.assign({}, this.diagramDataInits);
      
    }, (error) => {
      alert( error );
    });
  }

  toggle(i) {
    switch (i) {
      case 0:
        this.versorgung = true;
        break;
      case 1:
        this.versorgung = false;
        break;   
      default:
        break;
    }
  }
  
  getNumArr(){
    let arr : Array<number> = [];
    for(let i = 1; i < this.max+1; i++){
      arr.push(i);
    }
    return arr;
  }
  
  onResize(){}
  
  calcLeft(num){
    let widthBar = document.getElementById('pBar').offsetWidth;
    let heightBar = document.getElementById('pBar').offsetHeight;    
    
    if( 
      widthBar > 0 &&
      heightBar > 0
    ) {
      
      this.styles[num] = {
        'left': (widthBar/this.max)*num - heightBar + "px"
      };  
      
      if(num > this.emBu.restleistungsvermoegenGrv){
        this.styles[num]['color'] = "#738999";
      }
    }
    
    return this.styles[num];
  }

}




// WEBPACK FOOTER //
// ./src/app/auswertung/em-bu/em-bu.component.ts